import React, {Component} from "react";
import InputText from "./InputText";
import InputSelect from "./InputSelect";
import ButtonSubmit from "./ButtonSubmit";
import InputDate from "./InputDate";
import InputHidden from "./inputHidden";
import OutputHtml from "./OutputHtml";
import InputTextarea from "./InputTextarea";
import OutputText from "./OutputText";
import ButtonSubmitSearch from "./ButtonSubmitSearch";
import InputRadio from "./InputRadio";
import InputRadioReverse from "./InputRadioReverse";
import InputCheck from "./InputCheck";
import InputUploadLogoOptions from "../specific/InputUploadLogoOptions";
import InputUploadVignette from "../specific/InputUploadVignette";
import InputUploadPhotosAnomalie from "../specific/InputUploadPhotosAnomalie";
import SpecificBlockOption from "../specific/SpecificBlockOption";
import SpecificBlockPrice from "../specific/SpecificBlockPrice";
import SpecificInputLabelEditorFr from "../specific/SpecificInputLabelEditorFr";
import SpecificInputLabelEditorEn from "../specific/SpecificInputLabelEditorEn";
import SpecificInputLabelEditorCn from "../specific/SpecificInputLabelEditorCn";


class BlockItem extends Component {
    constructor(props) {
        super(props);
        this.biRef = React.createRef();
    }

    componentDidMount() {
        this.props.updateScale(this.biRef.current.offsetTop + this.biRef.current.offsetHeight);
    }

    render() {
        return (
            <div ref={this.biRef} className={"BLOCK_ITEM_" + this.props.blockItem.id + " " + this.props.blockItem.class}
                 style={{left: this.props.blockItem.positionX + 'px', top: this.props.blockItem.positionY + 'px'}}>
                {this.props.blockItem.isInput &&
                <div className="coreBlockItem-label" style={JSON.parse(this.props.blockItem.labelCss)}>
                    <span>{this.props.blockItem.label}</span>
                </div>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificInputUploadLogoOptions.jsp' &&
                <InputUploadLogoOptions
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificInputUploadVignette.jsp' &&
                    <InputUploadVignette
                        blockItem={this.props.blockItem}
                        onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/InputUploadPhotosAnomalie.jsp' &&
                <InputUploadPhotosAnomalie
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificBlockPrice.jsp' &&
                <SpecificBlockPrice
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificBlockOption.jsp' &&
                <SpecificBlockOption
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificInputLabelEditorFr.jsp' &&
                <SpecificInputLabelEditorFr
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificInputLabelEditorEn.jsp' &&
                <SpecificInputLabelEditorEn
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.view === '/public/jsp/core/specific/blockItem/SpecificInputLabelEditorCn.jsp' &&
                <SpecificInputLabelEditorCn
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 1 &&
                <InputText
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 2 &&
                <InputSelect
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 3 &&
                <InputDate
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 4 &&
                <InputCheck
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 5 &&
                <InputRadio
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 23 &&
                <InputRadioReverse
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 6 &&
                <InputTextarea
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 8 &&
                <ButtonSubmit
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 9 &&
                <OutputText
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 12 &&
                <OutputHtml
                    blockItem={this.props.blockItem}
                    externalCall={this.props.externalCall}/>
                }
                {this.props.blockItem.type === 13 &&
                <InputHidden
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {this.props.blockItem.type === 19 &&
                <ButtonSubmitSearch
                    blockItem={this.props.blockItem}
                    onChange={this.props.onChange}/>
                }
                {!this.props.blockItem.isButton && !!(this.props.blockItem.label2) &&
                <div className="coreBlockItem-label">
                    <span className="coreBlockItem-label2">{this.props.blockItem.label2}</span>
                </div>
                }
            </div>
        );
    }
}

export default BlockItem;